exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-textarea.is-disabled[data-v-fb6027f6] .el-textarea__inner{background-color:#f7f7f7;border-color:#e1e4ea}.el-textarea.isView[data-v-fb6027f6] .el-textarea__inner{background-color:#f7f7f7}\n", ""]);

// exports
